import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { Grid, makeStyles, Container } from '@material-ui/core';

import Banner from '../../components/Banner';

import InsuranceTypes from '../../components/InsuranceTypes';
import MyInsurances from '../../components/MyInsurances';

import { fetchUserAuth } from '../../redux/user';
import { setErrorMessage } from '../../redux/errors';
import { mapErrorMessage } from '../../utils';

import HeadingWithLine from '../../components/HeadingWithLine';

const useStyles = makeStyles({
  container: {
    maxWidth: '1008px',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
    marginBottom: 36,
  },
});

export default function Home(props) {
  const classes = useStyles();
  let history = useHistory();
  const userValidated = useRef(false);
  const urlQuery = useLocation().search;
  const { isIE } = props;

  const dispatch = useDispatch();
  const { user, isAuth } = useSelector(({ user, auth }) => ({
    user,
    isAuth: auth.token && true,
  }));

  useEffect(() => {
    if (!userValidated.current && !isAuth && !isIE) {
      let { token } = queryString.parse(urlQuery);
      if (!token) {
        dispatch(setErrorMessage(mapErrorMessage('invalidToken')));
        history.push(`/error`);
      } else {
        token = token && token.replace(/ /g, '+');
        dispatch(fetchUserAuth(token));
        userValidated.current = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Banner />
      {user.userValidated && (
        <Container className={classes.container}>
          <Grid container justify='center'>
            <Grid item xs={12}>
              <HeadingWithLine
                text={
                  <>
                    Hola {user.nombre}, <b>Consultá</b> y <b>Contratá</b> tu
                    próximo seguro 100% online{' '}
                  </>
                }
              />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12} container>
              <InsuranceTypes />
            </Grid>
            <Grid item xs={12} style={{ marginTop: 28 }}>
              <MyInsurances />
            </Grid>
          </Grid>
        </Container>
      )}
    </React.Fragment>
  );
}
